(function () {
  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isEnglishPage() {
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    const path = window.location.pathname.toLowerCase();
    return htmlLang.indexOf('en') === 0 || path.indexOf('/en') === 0 || path.indexOf('/en/') === 0;
  }

  function replaceTextInNode(node, dictionary) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;

    const original = node.nodeValue;
    const normalized = normalize(original);

    if (!normalized) return;

    if (dictionary.hasOwnProperty(normalized)) {
      node.nodeValue = original.replace(normalized, dictionary[normalized]);
      return;
    }

    if (
      normalized === 'Translation missing: bg.general.language' ||
      normalized === 'Translation missing: en.general.language'
    ) {
      node.nodeValue = '';
    }
  }

  function processElement(el, dictionary) {
    if (!el) return;

    if (el.nodeType === Node.TEXT_NODE) {
      replaceTextInNode(el, dictionary);
      return;
    }

    if (el.nodeType !== Node.ELEMENT_NODE) return;

    const text = normalize(el.textContent);

    if (
      text === 'Translation missing: bg.general.language' ||
      text === 'Translation missing: en.general.language'
    ) {
      el.style.display = 'none';
      return;
    }

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    let textNode;
    while ((textNode = walker.nextNode())) {
      replaceTextInNode(textNode, dictionary);
    }
  }

  function runTranslations() {
    if (!isEnglishPage()) return;
    if (!window.themeTranslations) return;

    processElement(document.body, window.themeTranslations);

    document.querySelectorAll('a, button, span, p, h1, h2, h3, h4, h5, h6, div, label').forEach(function (el) {
      const text = normalize(el.textContent);

      if (window.themeTranslations.hasOwnProperty(text)) {
        el.textContent = window.themeTranslations[text];
      }

      if (
        text === 'Translation missing: bg.general.language' ||
        text === 'Translation missing: en.general.language'
      ) {
        el.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runTranslations();

    setTimeout(runTranslations, 300);
    setTimeout(runTranslations, 1000);
    setTimeout(runTranslations, 2000);

    const observer = new MutationObserver(function () {
      runTranslations();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();